import SurveyView from '../views/SurveyView';
window.SurveyView = SurveyView;
